/**
 * Email link tokens (verification, password reset) arrive as `?token=…` on the
 * landing URL. SCHEMA.md ("Email verification & password reset") makes getting
 * rid of them the page's duty: the token is a live single-use credential, and
 * leaving it in the address bar leaks it into browser history, bookmarks, and
 * the `Referer` header of anything the page loads next.
 *
 * So reading and stripping happen together, in one call, against
 * `window.location` — the object `history.replaceState` actually rewrites.
 * (Reading through react-router's `useSearchParams` instead would leave the
 * two out of step under MemoryRouter.)
 *
 * Returns the token, or '' when the link carried none.
 */
export function takeLinkToken() {
	const { search, pathname, hash } = window.location;
	const params = new URLSearchParams(search);

	if (!params.has('token')) return '';

	const token = params.get('token') || '';

	params.delete('token');
	const rest = params.toString();

	// The existing history state is carried over rather than replaced: react
	// router v6 keeps its own `idx` bookkeeping there, and dropping it breaks
	// back/forward navigation for the rest of the session.
	window.history.replaceState(
		window.history.state,
		'',
		`${pathname}${rest ? `?${rest}` : ''}${hash}`
	);

	return token;
}
